module.exports = __webpack_public_path__ + "img/documents.0c51bd44.svg";